export default __webpack_public_path__ + "static/studienkreis-140b4c9cf7810ed5b1b774074c536e52.jpg";